import { Button, ButtonProps } from "@heroui/react";
import clsx from "clsx";

interface EditorButtonProps extends Omit<ButtonProps, "onPress"> {
  isMobile: boolean;
  onPress: () => void;
}

export function EditorButton({
  children,
  isIconOnly = true,
  isMobile,
  style,
  variant = "light",
  onPress,
  isDisabled = false,
  ...rest
}: EditorButtonProps) {
  return isMobile ? (
    <button
      disabled={isDisabled}
      className={clsx("justify hover:bg-default/40 flex flex-none items-center justify-center rounded-lg text-sm", {
        "bg-default hover:bg-default/85": variant === "solid",
        "size-9": isIconOnly,
        "h-9 px-4": !isIconOnly,
        "text-default-400": isDisabled,
      })}
      style={style}
      onClick={onPress}
      onMouseDown={(e) => e.preventDefault()}
    >
      {children}
    </button>
  ) : (
    <Button
      isDisabled={isDisabled}
      isIconOnly={isIconOnly}
      size="sm"
      style={style}
      variant={variant}
      onPress={onPress}
      {...rest}
    >
      {children}
    </Button>
  );
}
